<div class="wuc-swipe-hand-animated"></div>
